export const PATHS = {
  HOME: '/',

  AUTH: '/auth',
  AUTH_REGISTER: '/auth?mode=register',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  CAPSULE: '/capsule/:id',
  CAPSULE_BY_ID: (id: string) => `/capsule/${id}`,
  CAPSULE_DONATION: '/capsule/:capsuleId/donation/:treeId',
  CAPSULE_DONATION_FUNC: (capsuleId: string, treeId: string) =>
    `/capsule/${capsuleId}/donation/${treeId}`,

  PROFILE: '/profile',
  PROFILE_WITH_TAB: (tab: string) => `/profile?tab=${tab}`,
  USER_PROFILE: '/user/:handle',
  USER_PROFILE_BY_HANDLE: (handle: string) => `/user/${handle}`,

  FEED: '/feed',

  CHAT: '/chat',
  CHAT_CONVERSATION: '/chat/:conversationId',
  CHAT_CONVERSATION_BY_ID: (conversationId: string) =>
    `/chat/${conversationId}`,
  CHAT_INVITE: '/chat/invite/:token',
  CHAT_INVITE_BY_TOKEN: (token: string) => `/chat/invite/${token}`,

  CAPSULES: '/capsules',
  CAPSULE_CREATE: '/capsules/create',
  CAPSULE_EDIT: '/capsules/edit/:id',
  CAPSULE_EDIT_BY_ID: (id: string) => `/capsules/edit/${id}`,
  FAQ: '/faq',
  ABOUT: '/about',

  TERMS: '/terms',

  TREE: '/tree',
  TREE_BY_ID: '/tree/:id',
  TREE_BY_ID_FUNC: (id: string) => `/tree/${id}`,

  PAYMENT: '/payment',
  PAYMENT_SUBSCRIPTION: '/payment/subscription',
} as const;

export type AppPath = (typeof PATHS)[keyof typeof PATHS];

export const createPath = (
  path: string,
  params: Record<string, string>
): string => {
  let result = path;

  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, value);
  });

  return result;
};
